// API URLs - Use environment variables with fallbacks for development
const ARCGIS_BASE_URL =
  process.env.REACT_APP_ARCGIS_BASE_URL ||
  "https://services7.arcgis.com/oQsBrSs8ovm1GWep/arcgis/rest/services";

const FIREBASE_DB_URL =
  process.env.REACT_APP_FIREBASE_DB_URL ||
  "https://fy20-wmi-website-default-rtdb.firebaseio.com";

const locationsURL = `${ARCGIS_BASE_URL}/Tampa_WMI_-_Projects_(Public)/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryPoint&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Foot&returnGeodetic=false&outFields=*&returnHiddenFields=false&returnGeometry=true&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson`;

const locationAttachmentsURL = `${ARCGIS_BASE_URL}/Tampa_WMI_-_Projects_(Public)/FeatureServer/0/queryAttachments?objectIds=&globalIds=&definitionExpression=1%3D1&attachmentsDefinitionExpression=&attachmentTypes=&size=&keywords=&resultOffset=&resultRecordCount=&returnUrl=true&f=pjson&token=`;

const alertsURL = `${ARCGIS_BASE_URL}/Tampa_WMI_-_Alerts_(Public)/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&returnGeodetic=false&outFields=*&returnHiddenFields=false&returnGeometry=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=json&token=`;

const alertAttachmentsURL = `${ARCGIS_BASE_URL}/Tampa_WMI_-_Alerts_(Public)/FeatureServer/0/queryAttachments?objectIds=&globalIds=&definitionExpression=1%3D1&attachmentsDefinitionExpression=&attachmentTypes=&size=&keywords=&resultOffset=&resultRecordCount=&returnUrl=true&returnCountOnly=false&cacheHint=false&f=json&token=`;

const dataURL = `${FIREBASE_DB_URL}/.json`;

/**
 * Fetch data with error handling
 * @param {string} url - The URL to fetch
 * @param {string} name - Name of the data source for error messages
 * @returns {Promise<any>} - Parsed JSON response
 */
const fetchWithErrorHandling = async (url, name) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch ${name}:`, error);
    throw new Error(`Failed to load ${name}. Please try again later.`);
  }
};

/**
 * Get all configuration data from ArcGIS and Firebase
 * @returns {Promise<Object>} - Combined data object
 */
export const getConfData = async () => {
  try {
    const [
      locationsData,
      locationAttachmentsData,
      alertsResponse,
      alertAttachmentsResponse,
      siteData,
    ] = await Promise.all([
      fetchWithErrorHandling(locationsURL, "project locations"),
      fetchWithErrorHandling(locationAttachmentsURL, "project attachments"),
      fetchWithErrorHandling(alertsURL, "alerts"),
      fetchWithErrorHandling(alertAttachmentsURL, "alert attachments"),
      fetchWithErrorHandling(dataURL, "site data"),
    ]);

    // Extract data with fallbacks for missing fields
    const locations = locationsData?.features || [];
    const locationAttachments = locationAttachmentsData?.attachmentGroups || [];
    const alerts = alertsResponse?.features || [];
    const alertAttachments = alertAttachmentsResponse?.attachmentGroups || [];
    const projectFaqs = siteData?.projectFaqs || [];
    const projectHighlights = siteData?.projectHighlights || [];
    const projectBenefits = siteData?.projectBenefits || [];
    const workforceFaqs = siteData?.workforceFaqs || [];
    const wmbeFaqs = siteData?.wmbeFaqs || [];

    return {
      locations,
      locationAttachments,
      alerts,
      alertAttachments,
      projectFaqs,
      projectHighlights,
      projectBenefits,
      workforceFaqs,
      wmbeFaqs,
    };
  } catch (error) {
    console.error("Error loading configuration data:", error);
    // Re-throw so the calling code can handle it
    throw error;
  }
};
